export default __webpack_public_path__ + "static/firstStep-a42741494a90a9633c900db97494e0b1.png";